module.exports = __webpack_public_path__ + "static/media/soxboxSignOnLogo.ce010055.svg";